/*
License

Copyright (c) 2022 Chukwubuikem Ume-Ugwa

Permission is hereby witheld, any person obtaining a copy
of this software and associated documentation files (the "Software"), cannot
use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software. These restrictions can be only lifted with
a written permission from Chukwubuikem Ume-Ugwa.
*/
export const getBG = mode => 'black';

export const getBootstrapBG = mode => 'black';

export const getBootstrapColor = mode => 'white';

export const getColor = mode => 'white';
